import { ModuleWithProviders, NgModule } from "@angular/core";
import { BantaSdkModule, ChatBackendService } from "@banta/sdk";
import { FirebaseChatBackend, FirebaseNotificationsProvider, FirebaseStoreRef } from "@banta/firebase";
import { BantaServiceChatBackend } from "@banta/client";
import { TYTBantaAuthentication } from "./tyt-banta-authentication";
import { TYTBantaAuthenticationProvider } from "./tyt-banta-authentication-provider";
import { TYTChatComponent } from "./chat/chat.component";
import { TYTCommentsComponent } from "./comments/comments.component";
import { MaterialSupportModule } from "@tytapp/app/material-support/material-support.module";
import { environment } from "@tytapp/environment";
import { CommonModule } from "@angular/common";
import { CommonUiModule } from "@tytapp/common-ui";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { ModerationModule } from "@tytapp/moderation";

@NgModule({
    declarations: [
        TYTChatComponent,
        TYTCommentsComponent
    ],
    imports: [
        CommonModule,
        CommonUiModule,
        BantaSdkModule,
        ModerationModule,
        MaterialSupportModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
    ],
    exports: [
        TYTChatComponent,
        TYTCommentsComponent
    ]
})
export class ChatModule {
    static forRoot(): ModuleWithProviders<ChatModule> {
        return {
            ngModule: ChatModule,
            providers: [
                TYTBantaAuthentication,
                TYTBantaAuthenticationProvider,
                FirebaseStoreRef,
                {
                    provide: FirebaseNotificationsProvider,
                    deps: [ FirebaseStoreRef ],
                    useFactory: storeRef => new FirebaseNotificationsProvider(storeRef)
                },
                {
                    provide: FirebaseChatBackend,
                    deps: [ TYTBantaAuthenticationProvider, FirebaseNotificationsProvider, FirebaseStoreRef ],
                    useFactory: (auth, notifs, storeRef) => new FirebaseChatBackend(auth, notifs, storeRef)
                },
                {
                    provide: ChatBackendService, 
                    deps: [ FirebaseChatBackend ],
                    useFactory: (firebaseBackend) => 
                        new BantaServiceChatBackend(firebaseBackend, environment.urls.bantaServer)
                }
            ]
        }
    }
}